<p-table [columns]="columnLabels.weeks" [value]="data">
  <ng-template pTemplate="header" let-columns>
    <tr [class]="'table__header--' + company | lowercase">
      <th class="table__header--uppercase">
        {{ columnLabels.title }}
      </th>
      <th *ngFor="let column of columns">
        <div>{{ column.header }}</div>
        <div *ngIf="column.subHeader">({{ column.subHeader }})</div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-data let-columns="columns">
    <tr>
      <td>
        {{ data.name }}
        <sup *ngFor="let noteCode of data.noteCodes">
          <ng-container *ngIf="notationMarks[noteCode]">{{ notationMarks[noteCode] }}</ng-container>
        </sup>
      </td>
      <td *ngFor="let column of columns">
        {{ data.prices[column.band] | lxPrice : { defaultValue: '-' } }}
      </td>
    </tr>
  </ng-template>
</p-table>
